<script lang="ts">
  import { onMount } from "svelte";
  import { ApiService } from "../../services/api.service";
	import BlueButton from "../BlueButton.svelte";

	import FormWithLabel from "../../molecules/FormWithLabel.svelte";
	import SectionBoard from "../../molecules/SectionBoard.svelte";

	let loading = false

	let name = ''
	let html = ''

	const handleName = (event) => {
		name = event.detail.value
	}

	const handleHtml = (event) => {
		html = event.detail.value
	}

	onMount(async () => {
		const client = ApiService.createClient()
		const { data } = await client.get('/fixedPage/privacyPolicy')
		if (!data.fixedPage) {
			return
		}
		name = data.fixedPage.name
		html = data.fixedPage.html
		console.log(data.fixedPage)
	})

	const savePrivacyPolicy = async () => {
		const client = ApiService.createClient()
		loading = true
		const { data } = await client.post('/fixedPage', {
			category: "privacyPolicy",
			name,
			html
		})
		console.log(data)
		loading = false
	}
</script>

<SectionBoard>
	<h2 class="font-semibold">
		プライバシーポリシー
	</h2>

	<div class="mt-6">
		<FormWithLabel
			label="名前"
			placeholder=""
			input={handleName}
			value={name}
		/>
	</div>

	<div class="mt-6">
		<FormWithLabel
			label="利用規約"
			input={handleHtml}
			value={html}
			inputType="textarea"
		/>
	</div>

	<BlueButton rounded klass="mt-4" click={savePrivacyPolicy} loading={loading}>
		更新する
	</BlueButton>
</SectionBoard>